import { DocsBlockPropertyDefinition, } from "./SDKDocsBlockProperty";
/** FigmaNode property - Definition */
export class DocsBlockFigmaNodePropertyDefinition extends DocsBlockPropertyDefinition {
}
